<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <!-- <div class="mb-1">
            <b-row>
              <b-col align="right">
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddCorrespondence"
                  title="Crea Indirizzo"
                  v-if="canVerb(resource, 'store')"
                  ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea</b-button
                >
              </b-col>
            </b-row>
          </div> -->
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newCorrespondanceBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Indirizzo cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewCorrespondance"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                  ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea</b-button
                >
              </div>
            </template>
            <template v-else>
              <div
                :class="`text-center empty-results ${
                  isTableInModal ? 'my-3' : 'my-5'
                }`"
              >
                <div
                  v-if="
                    isTableInModal ||
                    performedSearch ||
                    automaticPerformedSearch
                  "
                  class="mb-1"
                >
                  Non sono stati trovati risultati
                </div>
                <template v-else-if="!isTableInModal">
                  <b-button
                    class="btn btn--smaller"
                    variant="primary"
                    size="sm"
                    title="Ricerca libera"
                    data-type="special-btn"
                    @click="freeSearch"
                  >
                    Nuova ricerca libera</b-button
                  >
                  <span class="or">oppure</span>
                  <b-button
                    :class="`btn--smaller btn--transparent align-items-center gap-3${
                      filterCount ? ' active' : ''
                    }`"
                    size="sm"
                    title="Apri i filtri"
                    data-type="special-btn"
                    v-b-toggle.sidebar-1
                  >
                    <base-icon name="filters" width="23" height="23" />Ricerca
                    con filtri{{ filterCount ? ` (${filterCount})` : "" }}
                  </b-button>
                </template>
              </div>
            </template>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                :title="`Modifica indirizzo di ${row.item.status_correspondence.text.toLowerCase()}`"
                :disabled="checkIsImported(row.item)"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
              <!-- destroy -->
              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="
                  onDestroy(row.item.id) &&
                    [1, 2].includes(row.item.status_correspondence.value)
                "
                class="mt-1 mr-1"
                :title="`Elimina indirizzo di ${row.item.status_correspondence.text.toLowerCase()}`"
              >
                <base-icon name="trash" width="22"></base-icon>
              </b-button>
            </div>
          </template>

          <template #cell(domicilio)="{ item }">
            <span
              v-html="
                toRelationString(
                  'correspondences',
                  item,
                  ['ADDR'],
                  [item.status_correspondence.value],
                )
              "
            ></span>
          </template>

          <template #cell(city)="{ item }" v-if="items.length">
            <!-- {{
                $store.state.auth.councils.find(
                  (e) => e.id == item.attributables.CITY
                ).title
              }} -->
            {{
              item.attributables.CITY2
                ? `${item.attributables.CITY2} - ${
                    $store.state.auth.countries.find(
                      (e) => e.id == item.attributables.NOR,
                    )?.title ?? ""
                  }`
                : $store.state.auth.councils.find(
                    (e) => e.id == item.attributables.CITY,
                  )?.title ?? ""
            }}
          </template>

          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                  ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-correspondences"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-correspondences"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <add-correspondence-modal
      :status_correspondence_allowed="getStatusCorrespondenceAllowed()"
      @create="onCreate"
    ></add-correspondence-modal> -->
  </div>
</template>

<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import BaseInputPagination from "@/components/form/BaseInputPagination";
// import AddCorrespondenceModal from "@/components/modals/addCorrespondenceModal";
// import FormMixin from "@/mixins/FormMixin";
// // import { showSnackbar } from "@/utils/messages";
export default {
  // mixins: [FormMixin],
  name: "CorrespondencesTable",
  extends: template,
  components: {
    BaseIcon,
    BaseInputPagination,
    // AddCorrespondenceModal
  },
  data() {
    return {
      // TODO default sorting (removed since 3.0.25.2 cos not working anymore)
      // sortBy: "status_correspondence",
      // sortDesc: false
    };
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newCorrespondanceBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkIsImported(item) {
      let isImported;
      const correspondenceType =
        item.status_correspondence.value === 0 ? true : false;
      if (
        Object.prototype.hasOwnProperty.call(item, "registry") &&
        Object.prototype.hasOwnProperty.call(item.registry, "insurer_id")
      ) {
        isImported = !item.registry.insurer_id ? false : true;
      } else {
        isImported = false;
      }
      return isImported && correspondenceType;
    },
    onAddNewCorrespondance() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    // getRegistryId() {
    //   let registry_id;
    //   if (this.filterOn && Object.keys(this.filterOn).length) {
    //     registry_id = this.filterOn.byRegistry.id
    //   }
    //   return registry_id
    // },
    // getStatusCorrespondenceAllowed() {
    //   // 0: una e una sola Residenza / Sede Legale, sempre
    //   // 1: nessun o al più un solo Domicilio / Sede Amministrativa
    //   // 2: n Indirizzi Alternaivi, con n >= 0
    //   // devo poter creare indirizzi di tipo 2, e di tipo 1 se non già presenti
    //   let ret = [2];
    //   let all = this.items.map((item) => item.status_correspondence.value)
    //   if (!all.includes(1)) {
    //     ret.push(1);
    //   }
    //   return ret
    // },
    // onAddCorrespondence() {
    //   // open the correspondence create modal
    //   this.$bvModal.show("addCorrespondenceModal");
    // },
    // onCreate(form) {
    //   this.$emit("create", form);
    // },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style lang="css" scoped></style>
